<div class="esf-overlay esf-js-closeModal" style="z-index: 200;" [ngClass]="{'-is-open': show}">
  <div class="esf-modal" [ngClass]="{'-is-open': show}">
    <header class="esf-modal__header">
      <h3>
        <span i18n="Heading text@@general.modalHeading.unsavedChanges">Unsaved changes</span>
      </h3>
    </header>
    <div class="esf-modal__inner">
      <div class="esf-text-block">
        <p i18n='Modal text@@general.modalText.leavePageText'>Are you sure you want to leave this page? Any data you have entered might be lost.</p>
      </div>
    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--filled" (click)="onConfirm()"
                  i18n="Action button@@general.button.yes">Yes</button>
        </div>
        <div class="esf-submit-row__item">
          <button i18n="Action button@@general.button.back" class="esf-button esf-button--standard esf-button--outlined"
                  (click)="onDismiss()">Back</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="onDismiss()">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>
